module.exports = __webpack_public_path__ + "static/media/technocate_1_iphoneplus.77b774bf.png";